import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  sectionContent: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginTop: theme.spacing(1),
  },
  createdAtDate: {
    fontSize: theme.spacing(2),
    color: theme.palette.labraText.tertiary,
    lineHeight: theme.spacing(3),
  },
  createdAtTime: {
    fontSize: theme.spacing(1.75),
    color: theme.palette.labraText.description,
    lineHeight: theme.spacing(2.5),
  },
  dateTimeWrapper: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
}))
